/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventName } from './';
import {
    ComplianceTimelineEventNameFromJSON,
    ComplianceTimelineEventNameFromJSONTyped,
    ComplianceTimelineEventNameToJSON,
} from './';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';
import type { ComplianceTimelineEventType } from './';
import {
    ComplianceTimelineEventTypeFromJSON,
    ComplianceTimelineEventTypeFromJSONTyped,
    ComplianceTimelineEventTypeToJSON,
} from './';
import type { ComplianceTimelinePartner } from './';
import {
    ComplianceTimelinePartnerFromJSON,
    ComplianceTimelinePartnerFromJSONTyped,
    ComplianceTimelinePartnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceTimelineEventResource
 */
export interface ComplianceTimelineEventResource {
    /**
     * 
     * @type {string}
     * @memberof ComplianceTimelineEventResource
     */
    eventId: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceTimelineEventResource
     */
    companyId: string;
    /**
     * 
     * @type {Date}
     * @memberof ComplianceTimelineEventResource
     */
    eventDate: Date;
    /**
     * 
     * @type {ComplianceTimelineEventName}
     * @memberof ComplianceTimelineEventResource
     */
    eventName: ComplianceTimelineEventName;
    /**
     * 
     * @type {ComplianceTimelineEventType}
     * @memberof ComplianceTimelineEventResource
     */
    type: ComplianceTimelineEventType;
    /**
     * 
     * @type {ComplianceTimelineEventPayload}
     * @memberof ComplianceTimelineEventResource
     */
    eventPayload?: ComplianceTimelineEventPayload;
    /**
     * 
     * @type {ComplianceTimelinePartner}
     * @memberof ComplianceTimelineEventResource
     */
    compliancePartner?: ComplianceTimelinePartner;
    /**
     * Link to the partner-related page for this event (partner dashboard, internal redirection, etc.), when one can be resolved. Absent when there is no partner, or the data needed to build the link is not available.
     * @type {string}
     * @memberof ComplianceTimelineEventResource
     */
    partnerLink?: string;
}

/**
 * Check if a given object implements the ComplianceTimelineEventResource interface.
 */
export function instanceOfComplianceTimelineEventResource(value: object): value is ComplianceTimelineEventResource {
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('eventDate' in value) || value['eventDate'] === undefined) return false;
    if (!('eventName' in value) || value['eventName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ComplianceTimelineEventResourceFromJSON(json: any): ComplianceTimelineEventResource {
    return ComplianceTimelineEventResourceFromJSONTyped(json, false);
}

export function ComplianceTimelineEventResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceTimelineEventResource {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'],
        'companyId': json['companyId'],
        'eventDate': (new Date(json['eventDate'])),
        'eventName': ComplianceTimelineEventNameFromJSON(json['eventName']),
        'type': ComplianceTimelineEventTypeFromJSON(json['type']),
        'eventPayload': json['eventPayload'] == null ? undefined : ComplianceTimelineEventPayloadFromJSON(json['eventPayload']),
        'compliancePartner': json['compliancePartner'] == null ? undefined : ComplianceTimelinePartnerFromJSON(json['compliancePartner']),
        'partnerLink': json['partnerLink'] == null ? undefined : json['partnerLink'],
    };
}

export function ComplianceTimelineEventResourceToJSON(value?: ComplianceTimelineEventResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eventId': value['eventId'],
        'companyId': value['companyId'],
        'eventDate': ((value['eventDate']).toISOString()),
        'eventName': ComplianceTimelineEventNameToJSON(value['eventName']),
        'type': ComplianceTimelineEventTypeToJSON(value['type']),
        'eventPayload': ComplianceTimelineEventPayloadToJSON(value['eventPayload']),
        'compliancePartner': ComplianceTimelinePartnerToJSON(value['compliancePartner']),
        'partnerLink': value['partnerLink'],
    };
}

